module.exports = __webpack_public_path__ + "static/media/swiftly-610.76eec938.mp3";